import React from "react";

export default function Info(props) {
  return (
    <div className="info-text">
      <p>{props.field.properties.text ? props.field.properties.text.nl : ""}</p>
    </div>
  );
}
